module.exports = __webpack_public_path__ + "img/37.85ef189b.png";